import React from 'react';
import { CheckCircle2, AlertTriangle, ShieldAlert } from 'lucide-react';
import type { HealthStatus } from './types';
import { STATUS_LABEL, statusClasses } from './formatHealth';

export const LivePulse: React.FC<{ status: HealthStatus; live: boolean }> = ({ status, live }) => {
  const cls = statusClasses(status);
  return (
    <span className="inline-flex items-center gap-2 text-xs font-medium text-[var(--muted-foreground)]">
      <span className="relative flex h-2.5 w-2.5" aria-hidden>
        {live && status === 'healthy' ? (
          <span className={`absolute inline-flex h-full w-full rounded-full ${cls.dot} opacity-40 motion-safe:animate-ping`} />
        ) : null}
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${cls.dot}`} />
      </span>
      {live ? 'Live' : 'Paused'}
    </span>
  );
};

export const StatusPill: React.FC<{ status: HealthStatus; large?: boolean }> = ({ status, large }) => {
  const cls = statusClasses(status);
  const Icon = status === 'critical' ? ShieldAlert : status === 'degraded' ? AlertTriangle : CheckCircle2;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${cls.bg} ${cls.text} ${
        large ? 'px-3 py-1 text-sm' : 'px-2.5 py-0.5 text-xs'
      }`}
    >
      <Icon className={large ? 'h-4 w-4' : 'h-3.5 w-3.5'} aria-hidden />
      {STATUS_LABEL[status]}
    </span>
  );
};
